import { render, staticRenderFns } from "./Auth_Screen_Registration.vue?vue&type=template&id=7c4970a7&"
import script from "./Auth_Screen_Registration.vue?vue&type=script&lang=js&"
export * from "./Auth_Screen_Registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports